// This is the base model
export class BaseModel {

  constructor() { }

  CreateObject(otherModel: any) {
    for (const key of Object.keys(otherModel)) {
      if (!(typeof (this[key]) === "undefined")) {
        this[key] = otherModel[key];
      }
    }
    return this;
  }

}
